export default "__VITE_ASSET__kt$voLbu__"